import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthHome from './components/Auth/AuthHome';
import RegisterForm from './components/Auth/RegisterForm';
import LoginForm from './components/Auth/LoginForm';
/* import PrivateRoute from './components/Common/PrivateRoute'; */
import AdminLayout from './components/Admin/AdminLayout';
/* import Dashboard from './components/Admin/Dashboard'; */
import UsuariosView from './components/Usuarios/Usuariosviews';
import CategoriasView from './components/Admin/CategoriasView';
import ProductsView from './components/Admin/ProductView';
import MesasView from './components/Admin/MesasView';
import MozoLayout from './components/Mozo/MozoLayout';
import DashboardMozo from './components/Mozo/DashboardMozo';
import PrivateRouteAdmin from './components/Common/PrivateRouteAdmin';
import PrivateRouteMozo from './components/Common/PrivateRouteMozo';
import CajeroLayout from './components/Cajero/CajeroLayout';
import PrivateRouteCajero from './components/Common/PrivateRouteCajero';
import PedidosView from './components/Cajero/PedidosView';
import CobrarMesasView from './components/Cajero/CobrarMesasView';
import DashboardCajero from './components/Cajero/DashboardCajero';
import PedidosEmitidosView from './components/Cajero/PedidosEmitidosView';
import CatalogoPublico from './components/Catalogo/CatalogoPublico';
import CatalogoAdmin from './components/Catalogo/CatalogoAdmin';
import PlanoSalon from './components/PlanoSalon/PlanoSalon';
import ReservasView from './components/Admin/ReservasView';
import TurnoCajaInfo from './components/Cajero/TurnoCajaInfo';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuthHome />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/catalogo/:slug" element={<CatalogoPublico />} />


        <Route path="/admin/:slug" element={
          <PrivateRouteAdmin>
            <AdminLayout />
          </PrivateRouteAdmin>
        }>
          <Route index /* element={<Dashboard />}  *//>
          <Route path="usuarios" element={<UsuariosView />} />
          <Route path="categorias" element={<CategoriasView />} />
          <Route path="productos" element={<ProductsView />} />
          <Route path="mesas" element={<MesasView />} />
          <Route path="catalogo" element={<CatalogoAdmin />} />
          <Route path="plano" element={<PlanoSalon editable={true} />} />
          <Route path="reservas" element={<ReservasView />} />


          {/* Más rutas después: productos, mesas, etc. */}
        </Route>

<Route path="/mozo/:slug" element={
  <PrivateRouteMozo>
    <MozoLayout />
  </PrivateRouteMozo>
}>
  <Route path="dashboard" element={<DashboardMozo />} />
  <Route path="mesas" element={<MesasView />} />

  {/* <Route path="perfil" element={<PerfilMozo />} /> */}
</Route>


<Route path="/cajero/:slug" element={<PrivateRouteCajero><CajeroLayout /></PrivateRouteCajero>}>
  <Route index element={<DashboardCajero />} />
  <Route path="dashboard" element={<DashboardCajero />} />
  <Route path="pedidos" element={<PedidosEmitidosView />} />
  <Route path="cobrar" element={<CobrarMesasView />} />
  <Route path="turno" element={<TurnoCajaInfo />} />
</Route>


    
      </Routes>
    </BrowserRouter>
  );
}

export default App;
